import { subscribe } from "../emitter-subscriber/subscribe";
import { setUserProfileId } from "../user/user-store";
import { rumSendAddSessionAttributes, rumSendDisableCookies, } from "../rum/rum-event";
/**
 * Creates a configuration object containing user-related functions.
 *
 * @returns An object with user-related functions, including `userSubscription`.
 *
 * @remarks
 * The `userSubscription` function subscribes to the "AAT_USER_PROFILE_ID" event.
 * When triggered, it updates the user profile ID and sends session attributes
 * using the provided payload.
 */
const config = () => {
    const userSubscription = () => {
        subscribe("AAT_USER_PROFILE_ID", (payload) => {
            setUserProfileId(payload);
            rumSendDisableCookies();
            rumSendAddSessionAttributes({ userProfileId: payload });
        });
    };
    return { userSubscription };
};
export const { userSubscription } = config();



//////////////////
// WEBPACK FOOTER
// ./~/@celine/passive-tracking/dist/events/user.js
// module id = ./node_modules/@celine/passive-tracking/dist/events/user.js
// module chunks = 0